<div class="error-container">
  <div class="error-content">
    <div class="error-header">
      <div class="error-icon">
        <qai-icon
          [kind]="'alert-circle'"
          [color]="'#F04438'"
          [size]="'24px'"
        ></qai-icon>
      </div>
      <h4 class="error-title">
        {{ "learningPathway.ERROR_TITLE" | transloco }}
      </h4>
    </div>
    <p class="error-message">
      <span class="error-message-text">{{
        "learningPathway.ERROR_MESSAGE" | transloco
      }}</span>
      <a
        qai-link
        [href]="'mailto:' + ('learningPathway.ERROR_HELP_EMAIL' | transloco)"
      >
        {{ "learningPathway.ERROR_HELP_EMAIL" | transloco }}
      </a>
    </p>
  </div>
</div>
